export const capitalizeFirstLetterOfEachWord = (words = '') => {
  if (typeof words !== 'string') {
    return '';
  }

  return words
    .split(' ')
    .map((word) => (word ? `${word[0].toUpperCase()}${word.substring(1)}` : ''))
    .join(' ');
};
